import ReactGA from "react-ga4";


const TRACKING_ID = 'G-FE6DHYM4Y9';
// @TODO: Do a proper check;
const isDevelopmentMode = window.location.hostname.includes('localhost')

export const initAnalytics = () => {
  if (isDevelopmentMode) return;
  ReactGA.initialize(TRACKING_ID);
}

export const logPageView = (path) => {
  if (isDevelopmentMode) return;
  ReactGA.set({ page: path });
};

export const logEvent = (category, action, label) => {
  if (isDevelopmentMode) {
    console.info('::Analytics::', {
      category,
      action,
      label,
    });
    return;
  };
  ReactGA.event({
    category,
    action,
    label,
  });
}